import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  Typography,
  Avatar,
  Tooltip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MenuHamburguerArrow from '../../MenuHamburgerArrow/';
import SideMenuDrawer from '../../../layouts/Dashboard/SideMenuDrawer';
import { NOTIFICATIONS ,PROFILE, MESSAGES, OPINIONS } from '../../../routes/';
import { useHistory } from 'react-router-dom';
import Popover from '@material-ui/core/Popover';
import Menu from '@material-ui/core/Menu';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import NotificationCard from '../../../components/NotificationCard';
import { connect } from 'react-redux';
import { markedReaded, setNotificationRead } from '../../../store/actions/UserAction';
import Snackbar from '../../Snackbar';

const logo = '/img/logo/logo-contacta-abogado.svg';
const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    //maxHeight: 521.2
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
));

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  avatar: {
    cursor: 'pointer',
    backgroundColor: 'white',
  },
  avatarPremium: {
    cursor: 'pointer',
    backgroundColor: 'white',
    border: '2px solid rgb(142, 117, 39)',
  },
  username: {
    marginRight: 18,
    paddingLeft: 24,
    borderLeft: '1px solid white',
  },
  bell: {
    marginRight: 12,
  },
}));

const HeaderDashboard = ({
  avatar,
  profile,
  notifications,
  isExpandedSideMenu,
  handleOpenSideMenu,
  openDrawer,
  handleToggleDrawer,
  markedReaded,
  setNotificationRead,
  pageNotifications,
  menuNotifications,
  allNotifications,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [feedbackMessage, setOpenFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });

  const classes = useStyles();
  const isTablet = useMediaQuery('(max-width:768px)');
  const defaultAvatar =
    profile && profile.role === 'lawyer'
      ? profile.genero === 'male'
        ? maleAvatar
        : femaleAvatar
      : lawFirmAvatar;
  const history = useHistory();

  const handleClick = (event, uidLawyer) => {
    if(menuNotifications && menuNotifications.length > 0){
      if(anchorEl){
        setAnchorEl(null);
      }else{
        setAnchorEl(event.currentTarget);
        //newNotifications && (newNotifications !== 0) && resetNewNotifications(uidLawyer); resets newNotifications
      }
    }else {
      history.push(NOTIFICATIONS)
    }

  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationClick = (notificationType) => {
    if(notificationType === 'messages'){
      setAnchorEl(null);
      history.push(MESSAGES)
    }else if(notificationType === 'Opinion'){
      setAnchorEl(null);
      history.push(OPINIONS)
    }
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const markAllAsReaded = async () => {
    const noReadNotifications = allNotifications && allNotifications.length && allNotifications.filter((n) => !n.read)
        .map(async(notification) => {
          if(!notification.read){
            return await setNotificationRead(notification, menuNotifications, pageNotifications.data, allNotifications)
          }
        });
        await Promise.all(noReadNotifications)
  };

  const membershipType = profile.membership && profile.membership.type;

  const handleCloseFeedbackMessage = () => {
    setOpenFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <Toolbar>
          <div
            style={{
              maxWidth: 1360,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              margin: '0 auto',
              padding: '0 24px',
            }}
          >
            {!isTablet && (
              <Link to="/">
                <img src={logo} alt="logo" className={classes.marginRight} />
              </Link>
            )}

            <div className={classes.title}>
              <MenuHamburguerArrow
                handleClick={handleOpenSideMenu}
                isChecked={!isExpandedSideMenu}
              />
            </div>

            {isTablet && (
              <Link to="/">
                <img src={logo} alt="logo" />
              </Link>
            )}

            {!isTablet && (
              <>
                {profile && profile.role !== 'admin' && (
                  <>
                    <IconButton
                      aria-describedby={id}
                      color="inherit"
                      aria-label="notifications"
                      className={classes.bell}
                      //onClick={handleOpenMenu}
                      onClick={(event) => {
                        profile && profile.role === 'cliente'
                          ? history.push('/notificaciones')
                          : handleClick(event, profile.uid);
                      }}
                    >
                      <Badge
                        /* badgeContent={
                          newNotifications? 
                          newNotifications : 0 
                        } */
                        badgeContent= {
                          allNotifications &&
                          allNotifications.filter((n) => !n.read).length }
                        max={99}
                        color="error"
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                        // variant="dot"
                      >
                        <NotificationsIcon />
                      </Badge>
                    </IconButton>
                    {menuNotifications &&
                          menuNotifications.length > 0 ?(
                    <StyledMenu
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                    >
                      <div>
                        <div
                          style={{
                            padding: 16,
                            maxWidth: 512,
                            display: 'flex',
                            justifyContent: 'space-between',
                            outline: 'none'
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: 14,
                              fontWeight: 'bold',
                              color: '#10587f',
                            }}
                          >
                            Tus notificaciones
                          </Typography>
                          <div
                            onClick={() => {
                              markAllAsReaded();
                            }}
                            component="button"
                            style={{
                              fontSize: '12px',
                              color: '#10587f',
                              backgroundColor: 'transparent',
                              border: 'none',
                              outline: 'none',
                              WebkitTapHighlightColor: 'transparent',
                              cursor: 'pointer',
                            }}
                          >
                            Marcar todas como leídas
                          </div>
                        </div>
                        <div style={{maxHeight: 400, overflow: 'auto'}}>
                        {menuNotifications &&
                          menuNotifications.length &&
                          menuNotifications
                            .map((notification, index) => {
                              return (
                                <div
                                  key={notification.uid}
                                  style={{ maxWidth: 824 }}
                                >
                                  <NotificationCard
                                    elevation={1}
                                    square={false}
                                    isDropdown={true}
                                    notification={notification}
                                    sender={notification.messageNotification.title}
                                    type={'notification.type'}
                                    description={
                                      <>
                                        {notification.messageNotification.instruction}
                                        <br />
                                        {notification.messageNotification.text}
                                      </>
                                    }
                                    date={notification.createdAt._seconds}
                                    featured={notification.featured}
                                    notificationUserType='notifications'
                                    read={notification.read}
                                    mediaWidth={isMobile ? 62 : 64}
                                    mediaHeight={isMobile ? 62 : 64}
                                    mediaMargin={isMobile ? 8 : 8}
                                    titleFontSize={isMobile ? 16 : 16}
                                    descriptionFontSize={isMobile ? 12 : 12}
                                    footerFontSize={isMobile ? 10 : 10}
                                    featuredPositionRight={isMobile ? 10 : 48}
                                    optionsButtonMargin={`${
                                      isMobile ? 26 : 6
                                    }px 6px 0 0`}
                                    handleNotificationClick={handleNotificationClick}
                                    roleUser = {profile.role}
                                    uidUser = {profile.uid}
                                    setOpenFeedbackMessage = {setOpenFeedbackMessage}
                                  />
                                </div>
                              );
                            })}

                        </div>
                        

                        <div style={{ padding: 16, textAlign: 'center' }} onClick={(e)=> setAnchorEl(null)}>
                          <Link
                          to={NOTIFICATIONS}
                            style={{
                              fontSize: '12px',
                              color: '#10587f',
                              backgroundColor: 'transparent',
                              border: 'none',
                              outline: 'none',
                              WebkitTapHighlightColor: 'transparent',
                              cursor: 'pointer',
                              textDecoration: 'none',
                            }}
                          >
                            Ver todas las notificaciones
                          </Link>
                        </div>
                      </div>
                    </StyledMenu>
                          ) : ''}
                  </>
                )}

                <Typography className={classes.username}>
                  {profile && profile.role === 'lawyer'
                    ? profile.name + ' ' + profile.firstLastName
                    : profile && profile.officeName
                    ? profile.officeName
                    : ''}
                </Typography>
                <Tooltip
                  title="Ir a Mi Perfil"
                  aria-label="Ir a Mi Perfil"
                  placement="bottom"
                >
                  <Link to={PROFILE}>
                    {profile && profile.imgProfile ? (
                      <Avatar
                        alt={
                          profile && profile.role === 'lawyer'
                            ? profile.name + ' ' + profile.firstLastName
                            : profile && profile.officeName
                            ? profile.officeName
                            : ''
                        }
                        src={profile.imgProfile}
                        className={
                          membershipType === 'Premium' ?
                          classes.avatarPremium :
                          classes.avatar
                        }
                      />
                    ) : (
                      <Avatar
                        alt={
                          profile && profile.role === 'lawyer'
                            ? profile.name + ' ' + profile.firstLastName
                            : profile && profile.officeName
                            ? profile.officeName
                            : ''
                        }
                        src={avatar ? avatar : defaultAvatar}
                        className={
                          membershipType === 'Premium' ?
                          classes.avatarPremium :
                          classes.avatar
                        }
                      />
                    )}
                  </Link>
                </Tooltip>
              </>
            )}
          </div>
        </Toolbar>
      </AppBar>

      {isTablet ? (
        <SideMenuDrawer
          isMobile={isTablet}
          variant="temporary"
          openDrawer={openDrawer}
          expandDrawer={true}
          handleToggleDrawer={handleToggleDrawer}
          profile={profile}
        />
      ) : null}

      <Snackbar
        open={feedbackMessage.open}
        variant={feedbackMessage.variant}
        message={feedbackMessage.message}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  markedReaded: (id, read, arrayNotify, uidLawyer, notificationUserType) =>
  dispatch(markedReaded(id, read, arrayNotify, uidLawyer, notificationUserType)),
  setNotificationRead: (notification, menuNotifications, pageNotifications, allNotifications) => dispatch(setNotificationRead(notification, menuNotifications, pageNotifications, allNotifications)),
  //resetNewNotifications: (uidLawyer) => dispatch(resetNewNotifications(uidLawyer))
});

const mapStateToProps = (state) => ({
  newNotifications: state.authClient.newNotifications,
  pageNotifications: state.authClient.notificationsPageLoad,
  allNotifications: state.authClient.notificationsLaw,
  menuNotifications: state.authClient.notificationsMenuLoad,
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderDashboard);
